import { render } from "./DashboardRelaciones.vue?vue&type=template&id=0fc52518"
import script from "./DashboardRelaciones.vue?vue&type=script&lang=js"
export * from "./DashboardRelaciones.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__